import { isNotNullish } from '@y42/util/nullish';
import { DataLineageUINode } from '../data-lineage-diagram.model';

// We need to keep the whole lineage model, in order to manipulate filters on snapshots. This method helps retain the node positions
export const getUpdatedLineageNodes = (fullModelNodes: DataLineageUINode[], currentModelNodes: DataLineageUINode[]) => {
  const currentNodesDictionary = currentModelNodes.reduce((dictionary, current) => {
    dictionary[current.key] = current;
    return dictionary;
  }, {} as Record<string, DataLineageUINode>);

  const updatedNodeDataArray = fullModelNodes
    .map((n) => {
      if (currentNodesDictionary[n.key]) {
        return currentNodesDictionary[n.key];
      }
      return n;
    })
    .filter(isNotNullish);

  return updatedNodeDataArray;
};
